import styled from '@emotion/styled'
import {Link} from 'gatsby'
import React from 'react'
import BreakPoints from '../../styles/breakPoints';

const StyledLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 160px;
  width: calc(100% / 5.5);
  height: 50px;
  font-size: 1.2em;
  line-height: 1em;
  font-weight: 600;
  border-radius: 8px;
  color: #00b5a6;
  background: #ffffff;
  border: solid 1px #3ec7b3;
  text-decoration: none !important;

  &:hover {
    text-decoration: none !important;
  }

  &:active {
    background: #3ec7b3;
  }

  ${BreakPoints.large} {
    font-size: 13px;
    padding: 0 5px;
  }
`

type Props = {
    /** クラス名 */
    className?: string
    /** リンク先 */
    href: string
    /** タイトル */
    label: string
}

/**
 * 共通ナビボタン風リンクタグ
 * @param props
 * @constructor
 */
const CommonNavLink = (props: Props): JSX.Element => {
    const {className = ''} = props

    return (
        <StyledLink className={className} to={props.href}>
            {props.label}
        </StyledLink>
    )
}

export default CommonNavLink
